<template>
  <div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        Notice Detail
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify Notice
      </div>
      <div slot="header" v-if="add && !lock">
        Register Notice
      </div>

      <b-form-group class="text-primary" label="Enable" label-for="ph_is_use">
        <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.is_use" :disabled="lock" />
      </b-form-group>
      <b-form-group class="text-primary">
        <label for="ph_title">Title</label>
        <b-input md=5 type="text" id="ph_title" v-model="model.title" :plaintext="lock" placeholder="Title"></b-input>
      </b-form-group>
      <b-form-group>
        <label for="ph_content" class="text-primary">Content</label>
        <div v-if="lock" class="ql-editor ql-snow" v-html="model.contents"></div>
        <vue-editor v-else v-model="model.contents" id="ph_content"></vue-editor>
      </b-form-group>
      <b-button size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right" v-if="profile.permission == 'Master'">
          <b-button class="mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { VueEditor } from 'vue2-editor'

import { api, auth } from '@/f1/service';

import 'vue-select/dist/vue-select.css';

const default_model = () => ({ is_use: true });

export default {
  components: { VueEditor, cSwitch, vSelect },
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      profile: auth.profile
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'notice', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'notice', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.board.notice.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('Notice deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'notice'}); },
    async save() {
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title required.'); }
      if(!(this.model.contents || '').trim()) { return this.$toastr.e('Contents required.'); }
      try {
        if(this.model.id) { await api.board.notice.update(this.model); }
        else { this.model.id = +(await api.board.notice.add(this.model)); }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try { this.model = Object.assign({}, this.model, await api.board.notice.get(id)); }
      catch(e) { this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  },
}
</script>
